import React from 'react'
import { Link } from 'react-router'
import { relativizeURL } from 'lib/Utils'
import './index.scss'

class HorizontalMenu extends React.Component {
  renderItemsList (items) {
    return (
      items.map((item) => {
        return (
          <li key={item.id}>
            <Link to={relativizeURL(item.link)} activeClassName='active'>{item.name}</Link>
          </li>
        )
      })
    )
  }

  render () {
    let items = this.props.items
    if (!items || items.length === 0) {
      return null
    }

    return (
      <ul className='horizontal-menu'>{this.renderItemsList(items)}</ul>
    )
  }
}

export default HorizontalMenu



// WEBPACK FOOTER //
// ./src/components/HorizontalMenu/index.js